"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var literals_1 = __importDefault(require("../../../literals"));
var LanguageContext_1 = __importDefault(require("../../Provider/LanguageContext"));
var Item_1 = __importDefault(require("../Item"));
var styles_1 = __importDefault(require("./styles"));
var Dropdown = function (_a) {
    var isHidden = _a.isHidden, options = _a.options, labelProp = _a.labelProp, selected = _a.selected, onClick = _a.onClick, onBulkSelect = _a.onBulkSelect;
    if (isHidden)
        return null;
    var _b = react_1.useState(''), query = _b[0], setQuery = _b[1];
    var language = react_1.useContext(LanguageContext_1.default);
    var bulkLabel = selected.length > 0 ? literals_1.default[language].unselectAll : literals_1.default[language].selectAll;
    var handleChange = function (event) {
        setQuery(event.currentTarget.value);
    };
    var isFiltered = function (label) {
        return label.toLowerCase().includes(query.toLowerCase());
    };
    var optionItems = options.map(function (x, i) { return (react_1.default.createElement(Item_1.default, { key: i, label: x[labelProp], isSelected: !!selected.find(function (s) { return s.id === x.id; }), onClick: onClick.bind(undefined, x), isHidden: !isFiltered(x[labelProp]) })); });
    var handleBulkSelect = function () {
        var filtered = options.filter(function (x) { return isFiltered(x[labelProp]); });
        onBulkSelect(filtered);
    };
    return (react_1.default.createElement(styles_1.default, null,
        react_1.default.createElement("button", { className: "bulk-select", onClick: handleBulkSelect }, bulkLabel),
        react_1.default.createElement("input", { className: "input", onChange: handleChange, placeholder: literals_1.default[language].search + "..." }),
        react_1.default.createElement("ul", { className: "options" }, optionItems)));
};
exports.default = Dropdown;
//# sourceMappingURL=index.js.map